export default __webpack_public_path__ + "locales/bg/SalesDepartmentRequestDialog.json?hash=c0bf87dbd2272686b98ae00cb313e75a";